import { getBridgeRoot } from '../../files/cwd/index.js';
import { resolveFileBrowserSessionParent } from '../../files/resolve-file-browser-session-parent.js';
import { normalizeResolvedPath } from '../../paths/normalize-resolved-path.js';
import type { SessionWorktreeManager } from '../../worktrees/manager.js';

export async function resolveCodeNavParentPath(
  sessionWorktreeManager: SessionWorktreeManager | undefined,
  sessionId: string | undefined,
): Promise<string> {
  const parent =
    sessionWorktreeManager != null
      ? await resolveFileBrowserSessionParent(sessionWorktreeManager, sessionId)
      : getBridgeRoot();
  return normalizeResolvedPath(parent);
}
